import { alpha } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  mainContainer: {
    width: '100%',
    maxWidth: '1300px',
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  flexColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputContainer: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: '70%',
  },
  removeButtonContainer: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  // A half-opaque scrim over the form while it loads. Derived from the
  // theme's own background so light and dark stay in step without a hex here.
  loadingProgress: {
    backgroundColor: alpha(theme.palette.background.paper, 0.5),
    zIndex: 1,
  },
  keyValuePairContainer: {
    gap: theme.spacing(2),
  },
  defaultOptionChip: {
    '&&': {
      margin: 0,
      marginLeft: theme.spacing(1),
      fontSize: 12,
      height: 18,
      minWidth: 0,
    },
  },
}));

export const useGeneratorsStyles = makeStyles()(theme => ({
  codeMirror: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    resize: 'vertical',
    overflow: 'hidden',
    minHeight: 100,
    '& .cm-theme, & .cm-editor': {
      height: '100%',
    },
    '& .cm-editor': {
      fontSize: '14px',
    },
  },
  codeMirrorDisabled: {
    opacity: theme.palette.action.disabledOpacity,
  },
  validationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    gap: theme.spacing(2),
  },
  validationCount: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    // The icon follows the count's error/warning/default colour rather than
    // the app stylesheet's `!important` accent for every icon.
    [`& .${svgIconClasses.root}`]: {
      color: 'inherit !important',
    },
  },
  validationDefaultStyle: {
    color: theme.palette.text.secondary,
  },
  validationErrorStyle: {
    color: theme.palette.error.main,
  },
  validationWarningStyle: {
    color: theme.palette.warning.main,
  },
}));
